export default "__VITE_ASSET__oltWeIoL__"